var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1C1C1C;}\n\t.st1{fill:#3F7F8A;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M28.4,8.2L16.7,1.5c-0.4-0.2-1-0.2-1.4,0L3.7,8.2C3.3,8.5,3,8.9,3,9.4v13.5c0,0.5,0.3,1,0.7,1.2l11.7,6.7 c0.4,0.2,1,0.2,1.4,0l11.7-6.7c0.4-0.2,0.7-0.7,0.7-1.2V9.4C29.1,8.9,28.8,8.5,28.4,8.2z M26.9,22.1c0,0.3-0.1,0.5-0.4,0.6 l-9.4,5.4c-0.4,0.2-0.8,0.1-1-0.3c-0.1-0.1-0.1-0.2-0.1-0.4V16.6c0-0.3-0.1-0.5-0.4-0.6l-9.4-5.4c-0.4-0.2-0.5-0.7-0.3-1 C6,9.4,6.1,9.3,6.2,9.2l2.6-1.5c0.5-0.3,1.2-0.3,1.7,0l9.7,5.6c0.2,0.1,0.4,0.4,0.4,0.6v2.2c0,0.4,0.3,0.7,0.7,0.7 c0.1,0,0.3,0,0.4-0.1l1.3-0.7c0.2-0.1,0.4-0.4,0.4-0.6v-3.1c0-0.3-0.1-0.5-0.4-0.6l-9.4-5.4c-0.4-0.2-0.5-0.7-0.3-1 c0.1-0.1,0.2-0.2,0.3-0.3l1.6-0.9c0.5-0.3,1.2-0.3,1.7,0l9.7,5.6c0.2,0.1,0.4,0.4,0.4,0.6L26.9,22.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M16,27.5c0,0.4,0.3,0.7,0.8,0.7c0.1,0,0.3,0,0.4-0.1l9.4-5.4c0.2-0.1,0.4-0.4,0.4-0.6V10.3 c0-0.1,0-0.3-0.1-0.4L23.2,12c0.1,0.1,0.1,0.2,0.1,0.4v3.1c0,0.3-0.1,0.5-0.4,0.6l-1.3,0.7c-0.4,0.2-0.8,0.1-1-0.3 c-0.1-0.1-0.1-0.2-0.1-0.4V14c0-0.1,0-0.3-0.1-0.4l-4.5,2.6c0.1,0.1,0.1,0.3,0.1,0.4V27.5z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.e276cacf3039f6cbda4f10b9c28ec9ac.svg";
export { ForwardRef as ReactComponent };